import React, { FC } from 'react';
import { StyledDiv, StyledFormMessageText, StyledIcon, StyledMessage } from './InformationsSection.styles';

export interface InformationsSectionProps {
  informationsLabel: string;
}

const InformationsSection: FC<InformationsSectionProps> = ({ informationsLabel }) => (
  <StyledDiv>
    <StyledMessage>
      <StyledIcon />
      <StyledFormMessageText>
        {informationsLabel}
      </StyledFormMessageText>
    </StyledMessage>
  </StyledDiv>
);

export default InformationsSection;
